import { render, staticRenderFns } from "./writeinvoiceHotel.vue?vue&type=template&id=bc3ef89a&scoped=true&"
import script from "./writeinvoiceHotel.vue?vue&type=script&lang=js&"
export * from "./writeinvoiceHotel.vue?vue&type=script&lang=js&"
import style0 from "./writeinvoiceHotel.vue?vue&type=style&index=0&id=bc3ef89a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3ef89a",
  null
  
)

export default component.exports